import React, { Suspense } from 'react'
import { withRouter, matchPath } from 'react-router-dom'
import { connect } from 'react-redux'
import { LanguageService } from '../../services/LanguageService'
import { setDemoMode, setPopUpsColorMode } from '../../actions/settings/SettingsAction'
import PopupListener from '../PopupListener'
import { getTranslations } from '../../actions/TranslationsAction'
import { RoutePath } from '../../constants/SitePaths'
import { popupHashes, PopupColorModeEnum, UiSettingModeEnum, PopupDisplaySettingsEnum } from '../base/PopupEnum'
import { DeviceTypeEnum } from '../../constants/DeviceTypeEnum'
import { Browser } from '../../services/helpers/Browser'
import Utils from '../../services/Utils'
import { LocalStorageService } from '../../services/LocalStorageService'
import { COLOR_MODE_KEY } from '../../constants/Enums/UiEnum'
const OneClickRegistrationFormSuccess = React.lazy(() => import('../registration/OneClickRegistrationFormSuccess'));
const CyprosTermsModal = React.lazy(() => import('../myProfile/responsibleGaming/CyprosTermsModal'));
class UserRedirect extends React.Component {
  componentDidMount() {
    if (this.props.languages.length) {
      this.userRedirect();
      this.props.dispatch(getTranslations(LanguageService.getSelectedLanguage()));
    }
    this.unlisten = this.props.history.listen((location, action) => {
      this.userRedirect();
      PopupListener.historyListener(this.props.history, location);
    });

    window.onpopstate = e => {
      PopupListener.historyListener(this.props.history, this.props.location, null, true);
    }

    Browser.getDeviceTypeByUserAgent(window.navigator.userAgent) == DeviceTypeEnum.MobileIOS && this.handleSafariChache()

  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  handleSafariChache = () => {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
  setLanguage = (languages) => {
    const selectedLang = LanguageService.getSelectedLanguageFromLocalStorage();
    if (!languages.find((element) => element.id === selectedLang)) {
      const defaultLanguage = languages.find((element) => element.isDefault) || languages[0];
      const defaultLanguageId = LanguageService.getDefaultBrowserLanguage(languages) || defaultLanguage.id || null;
      defaultLanguageId && LanguageService.setSelectedLanguage(defaultLanguageId);
    } else {
      LanguageService.setSelectedLanguage(selectedLang);
    }
  }



  userRedirect = () => {
    const { languages, demoMode, history } = this.props;
    let pathname;
    try {
      pathname = `${decodeURIComponent(history.location.pathname)}${history.location.search}`;
    } catch (error) {
      pathname = `${(history.location.pathname)}${history.location.search}`;
    }
    const isDemoMode = history.location.search.match(/(template=[0-9])+/);

    this.redirectToHomePage();

    if (isDemoMode && !demoMode) {
      this.props.dispatch(setDemoMode(isDemoMode[0]));
    }
    if (demoMode && !isDemoMode) {
      setTimeout(() => {
        history.replace(`${pathname}?${demoMode}`) //+ referId
      }, 0)

    }

    //TODO after while
    // const hashName = decodeURIComponent(history.location.hash);

    // if (hashName) {
    //   const pathNoHashes = `/${pathname}${hashName.replace(/#/gi, '/')}`;
    //   const pathNoDoubleSlashes = pathNoHashes.replace(/\/\/+/g, '/');
    //   const normalizedPath = '/' + pathNoDoubleSlashes.replace(/^\//g, '').replace('modal-', 'popup/')
    //   PopupListener.historyListener(history, { pathname: normalizedPath }, 'call');
    //   this.props.history.replace(normalizedPath) //+ referId
    // }

    if (languages.length) {

      this.setLanguage(languages);

      if (LanguageService.getSelectedLanguage() && !Utils.isLanguageInPath(pathname, LanguageService.getSelectedLanguage())) {
        const selectedOtherLanguage = languages.find(language => Utils.isLanguageInPath(pathname, language.id));
        let nextPath = pathname;
        if (selectedOtherLanguage) {
          nextPath = nextPath.replace(`/${selectedOtherLanguage.id}`, ``);
          LanguageService.setSelectedLanguage(selectedOtherLanguage.id);
          this.props.dispatch(getTranslations(LanguageService.getSelectedLanguage()));
        }
        var redirectPath = LanguageService.getSelectedLanguage() + nextPath;
        let demoPath = ''
        if (demoMode) {
          if (!redirectPath.match(/(template=[0-9])+/)) {
            demoPath = '?' + demoMode;
          }
        }
        if (nextPath !== pathname || !Utils.isLanguageInPath(nextPath, LanguageService.getSelectedLanguage())) {
          setTimeout(() => {
            history.replace(`/${redirectPath}${decodeURIComponent(history.location.hash)}${demoPath}`) //+ referId
          }, 0)
        }
      }
    }
  };

  // redirect to home page, if its not default
  redirectToHomePage = () => {
    const { homePageInfo, history } = this.props;

    const matchHomePage = matchPath(history.location.pathname, {
      path: `/:lang?${RoutePath.DEFAULT}`,
      exact: true,
      strict: false
    });

    if (homePageInfo && homePageInfo.isSystem && homePageInfo.prefix + homePageInfo.alias !== RoutePath.HOMEPAGE && matchHomePage && LanguageService.getSelectedLanguage()) {
      // history.replace(`/${LanguageService.getSelectedLanguage()}${homePageInfo.prefix + homePageInfo.alias}`);
      setTimeout(() => {
        history.replace(`/${LanguageService.getSelectedLanguage()}${homePageInfo.prefix + homePageInfo.alias}${history.location.search}`);
      }, 0)
    }

  }


  componentDidUpdate(prevProps) {
    const { tab, subTab } = this.props.selectedSubTab ? this.props.selectedSubTab : {};
    const { tab: prevTab, subTab: prevSubTab } = prevProps.selectedSubTab ? prevProps.selectedSubTab : {};
    if (this.props.popupVisible !== prevProps.popupVisible || tab !== prevTab || subTab !== prevSubTab) {
      PopupListener.handlePopupVisibleChange(this.props.history.location.pathname, this.props.popupVisible, this.props.selectedSubTab,
        this.props.location, this.props.history);
    }


    if (this.props.languages.length && !prevProps.languages.length) {
      this.userRedirect();
      this.props.dispatch(getTranslations(LanguageService.getSelectedLanguage()));
    }

    if (this.props.homePageInfo && !prevProps.homePageInfo) {
      this.redirectToHomePage(this.props.history);
    }
    if (this.props.activePromoCode && this.props.activePromoCode !== prevProps.activePromoCode) {
      const params = PopupListener.matchPopupParams(this.props.location.pathname);
      const popupName = params.popupName ? 'popup/' + params.popupName : '';
      popupName === popupHashes.promocodes.val && PopupListener.historyListener(this.props.history, this.props.location, null, true);
    }
  }

  popupColorHandler = (value) => {
    switch (value) {
      case PopupColorModeEnum.Light:
        return 'light-mode';
      case PopupColorModeEnum.Dark:
        return 'dark-mode';
      case PopupColorModeEnum.Night:
        return 'night-mode';
      default:
        break;
    }
  }

  render() {
    if (Utils.isRTL()) {
      if (!document.body.classList.contains('tb--rtl')) {
        document.body.classList.add('tb--rtl');
      }
    } else {
      document.body.classList.contains('tb--rtl') && document.body.classList.remove('tb--rtl');
    }
    let { popUpSettings, uiSettingMode } = this.props;

    // let popupColorModeClass = '';
    const storageData = LocalStorageService.get(COLOR_MODE_KEY);
    uiSettingMode = +(storageData?.mode ? storageData.mode : uiSettingMode);

    // if (popUpSettings) {
    //   if (uiSettingMode) {
    //     const selectedMode = UiSettingModeEnum[uiSettingMode];
    //     this.props.dispatch(setPopUpsColorMode(popUpSettings[selectedMode]));
    //     popupColorModeClass = this.popupColorHandler(popUpSettings[selectedMode]);
    //   } else {
    //     popupColorModeClass = this.popupColorHandler(popUpSettings?.popUpColorMode);
    //     this.props.dispatch(setPopUpsColorMode(popUpSettings?.popUpColorMode));
    //   }
    // } else {
    //   // in case of not updated state
    //   popupColorModeClass = 'dark-mode';
    //   this.props.dispatch(setPopUpsColorMode(PopupColorModeEnum.Dark));
    // }
    // if (popupColorModeClass) {
    //   document.body.classList.remove("night-mode", "dark-mode", "light-mode")
    //   document.body.classList.add(popupColorModeClass)
    // }

    if (uiSettingMode) {
      const colorMode = uiSettingMode ? (uiSettingMode === 2 && 'light' || uiSettingMode === 1 && 'dark') : null

      if (colorMode) {
        document.documentElement.dataset.theme = colorMode
      }
    }
    const [inputRadiusTopLeft, inputRadiusTopRight, inputRadiusBottomLeft, inputRadiusBottomRight] = [
      getComputedStyle(document.body).getPropertyValue('--input-radius-top-left').trim(),
      getComputedStyle(document.body).getPropertyValue('--input-radius-top-right').trim(),
      getComputedStyle(document.body).getPropertyValue('--input-radius-bottom-left').trim(),
      getComputedStyle(document.body).getPropertyValue('--input-radius-bottom-right').trim(),
    ]
    if (inputRadiusTopLeft.substring(0, inputRadiusTopLeft.length - 2) >= 12) {
      document.body.classList.add('tb--br-left')
    }
    if (inputRadiusTopRight.substring(0, inputRadiusTopRight.length - 2) >= 12) {
      document.body.classList.add('tb--br-right')
    }

    if (inputRadiusBottomLeft.substring(0, inputRadiusBottomLeft.length - 2) >= 12 || inputRadiusBottomRight.substring(0, inputRadiusBottomRight.length - 2) >= 12) {
      document.body.classList.add('tb--br-bottom')
    }

    const btnBorderRadiusTopLeft = getComputedStyle(document.body).getPropertyValue('--btn-radius-top-left').trim()
    const btnBorderRadiusTopRight = getComputedStyle(document.body).getPropertyValue('--btn-radius-top-right').trim()
    const btnBorderRadiusBottomLeft = getComputedStyle(document.body).getPropertyValue('--btn-radius-bottom-left').trim()
    const btnBorderRadiusBottomRight = getComputedStyle(document.body).getPropertyValue('--btn-radius-bottom-right').trim()
    if (btnBorderRadiusTopLeft.substring(0, btnBorderRadiusTopLeft.length - 2) == 20 || btnBorderRadiusTopRight.substring(0, btnBorderRadiusTopRight.length - 2) == 20 || btnBorderRadiusBottomLeft.substring(0, btnBorderRadiusBottomLeft.length - 2) == 20 || btnBorderRadiusBottomRight.substring(0, btnBorderRadiusBottomRight.length - 2) == 20) {
      document.body.classList.add('tb--btn-br')
    }

    if (document.getElementsByClassName('tb--categories-list_reach-portal')[0]) {
      document.body.classList.add('floating--ico-hide')
    }
    return (
      <>
        {this.props.oneClickLogin ? <Suspense fallback={<></>}><OneClickRegistrationFormSuccess isPopup={true} /></Suspense> : <></>}
        <Suspense fallback={<></>}><CyprosTermsModal /></Suspense>
      </>
    )
  }
}
const mapStateToProps = (state) => {
  return ({
    popupVisible: state.ui.popupVisible,
    languages: state.settings.languages,
    demoMode: state.settings.demoMode,
    selectedSubTab: state.ui.selectedSubTab,
    homePageInfo: state.settings.homePageInfo,
    activePromoCode: state.settings.bonusSettings?.promoCodeEnabled,
    popUpSettings: state.settings.popUpSettings,
    uiSettingMode: state.settings.uiSettingMode,
    oneClickLogin: state.user.oneClickLogin,
    popupDisplaySettings: state.settings.popupDisplaySettings

  })
}

const mapDispatchToProps = (dispatch, props) => {
  return ({
    dispatch,
    props
  })
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRedirect));
